import { c as x } from "./@contentful-cca97bae.js";
import { d as O } from "./entities-09dd0ad3.js";
import { l as q } from "./domhandler-44c667b9.js";
import { l as M } from "./domelementtype-4b6931b4.js";
import { l as _ } from "./domutils-84360663.js";
var F = {}, A = {}, w = {};
(function(a) {
  Object.defineProperty(a, "__esModule", { value: !0 }), a.QuoteType = void 0;
  var n = O, s;
  (function(t) {
    t[t.Tab = 9] = "Tab", t[t.NewLine = 10] = "NewLine", t[t.FormFeed = 12] = "FormFeed", t[t.CarriageReturn = 13] = "CarriageReturn", t[t.Space = 32] = "Space", t[t.ExclamationMark = 33] = "ExclamationMark", t[t.Number = 35] = "Number", t[t.Amp = 38] = "Amp", t[t.SingleQuote = 39] = "SingleQuote", t[t.DoubleQuote = 34] = "DoubleQuote", t[t.Dash = 45] = "Dash", t[t.Slash = 47] = "Slash", t[t.Zero = 48] = "Zero", t[t.Nine = 57] = "Nine", t[t.Semi = 59] = "Semi", t[t.Lt = 60] = "Lt", t[t.Eq = 61] = "Eq", t[t.Gt = 62] = "Gt", t[t.Questionmark = 63] = "Questionmark", t[t.UpperA = 65] = "UpperA", t[t.LowerA = 97] = "LowerA", t[t.UpperF = 70] = "UpperF", t[t.LowerF = 102] = "LowerF", t[t.UpperZ = 90] = "UpperZ", t[t.LowerZ = 122] = "LowerZ", t[t.LowerX = 120] = "LowerX", t[t.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(s || (s = {}));
  var e;
  (function(t) {
    t[t.Text = 1] = "Text", t[t.BeforeTagName = 2] = "BeforeTagName", t[t.InTagName = 3] = "InTagName", t[t.InSelfClosingTag = 4] = "InSelfClosingTag", t[t.BeforeClosingTagName = 5] = "BeforeClosingTagName", t[t.InClosingTagName = 6] = "InClosingTagName", t[t.AfterClosingTagName = 7] = "AfterClosingTagName", t[t.BeforeAttributeName = 8] = "BeforeAttributeName", t[t.InAttributeName = 9] = "InAttributeName", t[t.AfterAttributeName = 10] = "AfterAttributeName", t[t.BeforeAttributeValue = 11] = "BeforeAttributeValue", t[t.InAttributeValueDq = 12] = "InAttributeValueDq", t[t.InAttributeValueSq = 13] = "InAttributeValueSq", t[t.InAttributeValueNq = 14] = "InAttributeValueNq", t[t.BeforeDeclaration = 15] = "BeforeDeclaration", t[t.InDeclaration = 16] = "InDeclaration", t[t.InProcessingInstruction = 17] = "InProcessingInstruction", t[t.BeforeComment = 18] = "BeforeComment", t[t.CDATASequence = 19] = "CDATASequence", t[t.InSpecialComment = 20] = "InSpecialComment", t[t.InCommentLike = 21] = "InCommentLike", t[t.BeforeSpecialS = 22] = "BeforeSpecialS", t[t.SpecialStartSequence = 23] = "SpecialStartSequence", t[t.InSpecialTag = 24] = "InSpecialTag", t[t.BeforeEntity = 25] = "BeforeEntity", t[t.BeforeNumericEntity = 26] = "BeforeNumericEntity", t[t.InNamedEntity = 27] = "InNamedEntity", t[t.InNumericEntity = 28] = "InNumericEntity", t[t.InHexEntity = 29] = "InHexEntity";
  })(e || (e = {}));
  function r(t) {
    return t === s.Space || t === s.NewLine || t === s.Tab || t === s.FormFeed || t === s.CarriageReturn;
  }
  function u(t) {
    return t === s.Slash || t === s.Gt || r(t);
  }
  function p(t) {
    return t >= s.Zero && t <= s.Nine;
  }
  function b(t) {
    return t >= s.LowerA && t <= s.LowerZ || t >= s.UpperA && t <= s.UpperZ;
  }
  function y(t) {
    return t >= s.UpperA && t <= s.UpperF || t >= s.LowerA && t <= s.LowerF;
  }
  var d;
  (function(t) {
    t[t.NoValue = 0] = "NoValue", t[t.Unquoted = 1] = "Unquoted", t[t.Single = 2] = "Single", t[t.Double = 3] = "Double";
  })(d = a.QuoteType || (a.QuoteType = {}));
  var f = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, I = (
    /** @class */
    function() {
      function t(i, o) {
        var g = i.xmlMode, v = g === void 0 ? !1 : g, h = i.decodeEntities, c = h === void 0 ? !0 : h;
        this.cbs = o, this.state = e.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = e.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = v, this.decodeEntities = c, this.entityTrie = v ? n.xmlDecodeTree : n.htmlDecodeTree;
      }
      return t.prototype.reset = function() {
        this.state = e.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = e.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, t.prototype.write = function(i) {
        this.offset += this.buffer.length, this.buffer = i, this.parse();
      }, t.prototype.end = function() {
        this.running && this.finish();
      }, t.prototype.pause = function() {
        this.running = !1;
      }, t.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, t.prototype.getIndex = function() {
        return this.index;
      }, t.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, t.prototype.stateText = function(i) {
        i === s.Lt || !this.decodeEntities && this.fastForwardTo(s.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = e.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && i === s.Amp && (this.state = e.BeforeEntity);
      }, t.prototype.stateSpecialStartSequence = function(i) {
        var o = this.sequenceIndex === this.currentSequence.length, g = o ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          u(i)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (i | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!g)
          this.isSpecial = !1;
        else if (!o) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = e.InTagName, this.stateInTagName(i);
      }, t.prototype.stateInSpecialTag = function(i) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (i === s.Gt || r(i)) {
            var o = this.index - this.currentSequence.length;
            if (this.sectionStart < o) {
              var g = this.index;
              this.index = o, this.cbs.ontext(this.sectionStart, o), this.index = g;
            }
            this.isSpecial = !1, this.sectionStart = o + 2, this.stateInClosingTagName(i);
            return;
          }
          this.sequenceIndex = 0;
        }
        (i | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === f.TitleEnd ? this.decodeEntities && i === s.Amp && (this.state = e.BeforeEntity) : this.fastForwardTo(s.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(i === s.Lt);
      }, t.prototype.stateCDATASequence = function(i) {
        i === f.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === f.Cdata.length && (this.state = e.InCommentLike, this.currentSequence = f.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = e.InDeclaration, this.stateInDeclaration(i));
      }, t.prototype.fastForwardTo = function(i) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === i)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, t.prototype.stateInCommentLike = function(i) {
        i === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === f.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = e.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : i !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, t.prototype.isTagStartChar = function(i) {
        return this.xmlMode ? !u(i) : b(i);
      }, t.prototype.startSpecial = function(i, o) {
        this.isSpecial = !0, this.currentSequence = i, this.sequenceIndex = o, this.state = e.SpecialStartSequence;
      }, t.prototype.stateBeforeTagName = function(i) {
        if (i === s.ExclamationMark)
          this.state = e.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (i === s.Questionmark)
          this.state = e.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(i)) {
          var o = i | 32;
          this.sectionStart = this.index, !this.xmlMode && o === f.TitleEnd[2] ? this.startSpecial(f.TitleEnd, 3) : this.state = !this.xmlMode && o === f.ScriptEnd[2] ? e.BeforeSpecialS : e.InTagName;
        } else
          i === s.Slash ? this.state = e.BeforeClosingTagName : (this.state = e.Text, this.stateText(i));
      }, t.prototype.stateInTagName = function(i) {
        u(i) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = e.BeforeAttributeName, this.stateBeforeAttributeName(i));
      }, t.prototype.stateBeforeClosingTagName = function(i) {
        r(i) || (i === s.Gt ? this.state = e.Text : (this.state = this.isTagStartChar(i) ? e.InClosingTagName : e.InSpecialComment, this.sectionStart = this.index));
      }, t.prototype.stateInClosingTagName = function(i) {
        (i === s.Gt || r(i)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = e.AfterClosingTagName, this.stateAfterClosingTagName(i));
      }, t.prototype.stateAfterClosingTagName = function(i) {
        (i === s.Gt || this.fastForwardTo(s.Gt)) && (this.state = e.Text, this.baseState = e.Text, this.sectionStart = this.index + 1);
      }, t.prototype.stateBeforeAttributeName = function(i) {
        i === s.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = e.InSpecialTag, this.sequenceIndex = 0) : this.state = e.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : i === s.Slash ? this.state = e.InSelfClosingTag : r(i) || (this.state = e.InAttributeName, this.sectionStart = this.index);
      }, t.prototype.stateInSelfClosingTag = function(i) {
        i === s.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = e.Text, this.baseState = e.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : r(i) || (this.state = e.BeforeAttributeName, this.stateBeforeAttributeName(i));
      }, t.prototype.stateInAttributeName = function(i) {
        (i === s.Eq || u(i)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = e.AfterAttributeName, this.stateAfterAttributeName(i));
      }, t.prototype.stateAfterAttributeName = function(i) {
        i === s.Eq ? this.state = e.BeforeAttributeValue : i === s.Slash || i === s.Gt ? (this.cbs.onattribend(d.NoValue, this.index), this.state = e.BeforeAttributeName, this.stateBeforeAttributeName(i)) : r(i) || (this.cbs.onattribend(d.NoValue, this.index), this.state = e.InAttributeName, this.sectionStart = this.index);
      }, t.prototype.stateBeforeAttributeValue = function(i) {
        i === s.DoubleQuote ? (this.state = e.InAttributeValueDq, this.sectionStart = this.index + 1) : i === s.SingleQuote ? (this.state = e.InAttributeValueSq, this.sectionStart = this.index + 1) : r(i) || (this.sectionStart = this.index, this.state = e.InAttributeValueNq, this.stateInAttributeValueNoQuotes(i));
      }, t.prototype.handleInAttributeValue = function(i, o) {
        i === o || !this.decodeEntities && this.fastForwardTo(o) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(o === s.DoubleQuote ? d.Double : d.Single, this.index), this.state = e.BeforeAttributeName) : this.decodeEntities && i === s.Amp && (this.baseState = this.state, this.state = e.BeforeEntity);
      }, t.prototype.stateInAttributeValueDoubleQuotes = function(i) {
        this.handleInAttributeValue(i, s.DoubleQuote);
      }, t.prototype.stateInAttributeValueSingleQuotes = function(i) {
        this.handleInAttributeValue(i, s.SingleQuote);
      }, t.prototype.stateInAttributeValueNoQuotes = function(i) {
        r(i) || i === s.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(d.Unquoted, this.index), this.state = e.BeforeAttributeName, this.stateBeforeAttributeName(i)) : this.decodeEntities && i === s.Amp && (this.baseState = this.state, this.state = e.BeforeEntity);
      }, t.prototype.stateBeforeDeclaration = function(i) {
        i === s.OpeningSquareBracket ? (this.state = e.CDATASequence, this.sequenceIndex = 0) : this.state = i === s.Dash ? e.BeforeComment : e.InDeclaration;
      }, t.prototype.stateInDeclaration = function(i) {
        (i === s.Gt || this.fastForwardTo(s.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = e.Text, this.sectionStart = this.index + 1);
      }, t.prototype.stateInProcessingInstruction = function(i) {
        (i === s.Gt || this.fastForwardTo(s.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = e.Text, this.sectionStart = this.index + 1);
      }, t.prototype.stateBeforeComment = function(i) {
        i === s.Dash ? (this.state = e.InCommentLike, this.currentSequence = f.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = e.InDeclaration;
      }, t.prototype.stateInSpecialComment = function(i) {
        (i === s.Gt || this.fastForwardTo(s.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = e.Text, this.sectionStart = this.index + 1);
      }, t.prototype.stateBeforeSpecialS = function(i) {
        var o = i | 32;
        o === f.ScriptEnd[3] ? this.startSpecial(f.ScriptEnd, 4) : o === f.StyleEnd[3] ? this.startSpecial(f.StyleEnd, 4) : (this.state = e.InTagName, this.stateInTagName(i));
      }, t.prototype.stateBeforeEntity = function(i) {
        this.entityExcess = 1, this.entityResult = 0, i === s.Number ? this.state = e.BeforeNumericEntity : i === s.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = e.InNamedEntity, this.stateInNamedEntity(i));
      }, t.prototype.stateInNamedEntity = function(i) {
        if (this.entityExcess += 1, this.trieIndex = (0, n.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, i), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var o = this.trieCurrent & n.BinTrieFlags.VALUE_LENGTH;
        if (o) {
          var g = (o >> 14) - 1;
          if (!this.allowLegacyEntity() && i !== s.Semi)
            this.trieIndex += g;
          else {
            var v = this.index - this.entityExcess + 1;
            v > this.sectionStart && this.emitPartial(this.sectionStart, v), this.entityResult = this.trieIndex, this.trieIndex += g, this.entityExcess = 0, this.sectionStart = this.index + 1, g === 0 && this.emitNamedEntity();
          }
        }
      }, t.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var i = (this.entityTrie[this.entityResult] & n.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (i) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~n.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, t.prototype.stateBeforeNumericEntity = function(i) {
        (i | 32) === s.LowerX ? (this.entityExcess++, this.state = e.InHexEntity) : (this.state = e.InNumericEntity, this.stateInNumericEntity(i));
      }, t.prototype.emitNumericEntity = function(i) {
        var o = this.index - this.entityExcess - 1, g = o + 2 + +(this.state === e.InHexEntity);
        g !== this.index && (o > this.sectionStart && this.emitPartial(this.sectionStart, o), this.sectionStart = this.index + Number(i), this.emitCodePoint((0, n.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, t.prototype.stateInNumericEntity = function(i) {
        i === s.Semi ? this.emitNumericEntity(!0) : p(i) ? (this.entityResult = this.entityResult * 10 + (i - s.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, t.prototype.stateInHexEntity = function(i) {
        i === s.Semi ? this.emitNumericEntity(!0) : p(i) ? (this.entityResult = this.entityResult * 16 + (i - s.Zero), this.entityExcess++) : y(i) ? (this.entityResult = this.entityResult * 16 + ((i | 32) - s.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, t.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === e.Text || this.baseState === e.InSpecialTag);
      }, t.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === e.Text || this.state === e.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === e.InAttributeValueDq || this.state === e.InAttributeValueSq || this.state === e.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, t.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, t.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var i = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case e.Text: {
              this.stateText(i);
              break;
            }
            case e.SpecialStartSequence: {
              this.stateSpecialStartSequence(i);
              break;
            }
            case e.InSpecialTag: {
              this.stateInSpecialTag(i);
              break;
            }
            case e.CDATASequence: {
              this.stateCDATASequence(i);
              break;
            }
            case e.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(i);
              break;
            }
            case e.InAttributeName: {
              this.stateInAttributeName(i);
              break;
            }
            case e.InCommentLike: {
              this.stateInCommentLike(i);
              break;
            }
            case e.InSpecialComment: {
              this.stateInSpecialComment(i);
              break;
            }
            case e.BeforeAttributeName: {
              this.stateBeforeAttributeName(i);
              break;
            }
            case e.InTagName: {
              this.stateInTagName(i);
              break;
            }
            case e.InClosingTagName: {
              this.stateInClosingTagName(i);
              break;
            }
            case e.BeforeTagName: {
              this.stateBeforeTagName(i);
              break;
            }
            case e.AfterAttributeName: {
              this.stateAfterAttributeName(i);
              break;
            }
            case e.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(i);
              break;
            }
            case e.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(i);
              break;
            }
            case e.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(i);
              break;
            }
            case e.AfterClosingTagName: {
              this.stateAfterClosingTagName(i);
              break;
            }
            case e.BeforeSpecialS: {
              this.stateBeforeSpecialS(i);
              break;
            }
            case e.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(i);
              break;
            }
            case e.InSelfClosingTag: {
              this.stateInSelfClosingTag(i);
              break;
            }
            case e.InDeclaration: {
              this.stateInDeclaration(i);
              break;
            }
            case e.BeforeDeclaration: {
              this.stateBeforeDeclaration(i);
              break;
            }
            case e.BeforeComment: {
              this.stateBeforeComment(i);
              break;
            }
            case e.InProcessingInstruction: {
              this.stateInProcessingInstruction(i);
              break;
            }
            case e.InNamedEntity: {
              this.stateInNamedEntity(i);
              break;
            }
            case e.BeforeEntity: {
              this.stateBeforeEntity(i);
              break;
            }
            case e.InHexEntity: {
              this.stateInHexEntity(i);
              break;
            }
            case e.InNumericEntity: {
              this.stateInNumericEntity(i);
              break;
            }
            default:
              this.stateBeforeNumericEntity(i);
          }
          this.index++;
        }
        this.cleanup();
      }, t.prototype.finish = function() {
        this.state === e.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, t.prototype.handleTrailingData = function() {
        var i = this.buffer.length + this.offset;
        this.state === e.InCommentLike ? this.currentSequence === f.CdataEnd ? this.cbs.oncdata(this.sectionStart, i, 0) : this.cbs.oncomment(this.sectionStart, i, 0) : this.state === e.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === e.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === e.InTagName || this.state === e.BeforeAttributeName || this.state === e.BeforeAttributeValue || this.state === e.AfterAttributeName || this.state === e.InAttributeName || this.state === e.InAttributeValueSq || this.state === e.InAttributeValueDq || this.state === e.InAttributeValueNq || this.state === e.InClosingTagName || this.cbs.ontext(this.sectionStart, i);
      }, t.prototype.emitPartial = function(i, o) {
        this.baseState !== e.Text && this.baseState !== e.InSpecialTag ? this.cbs.onattribdata(i, o) : this.cbs.ontext(i, o);
      }, t.prototype.emitCodePoint = function(i) {
        this.baseState !== e.Text && this.baseState !== e.InSpecialTag ? this.cbs.onattribentity(i) : this.cbs.ontextentity(i);
      }, t;
    }()
  );
  a.default = I;
})(w);
var j = x && x.__createBinding || (Object.create ? function(a, n, s, e) {
  e === void 0 && (e = s);
  var r = Object.getOwnPropertyDescriptor(n, s);
  (!r || ("get" in r ? !n.__esModule : r.writable || r.configurable)) && (r = { enumerable: !0, get: function() {
    return n[s];
  } }), Object.defineProperty(a, e, r);
} : function(a, n, s, e) {
  e === void 0 && (e = s), a[e] = n[s];
}), U = x && x.__setModuleDefault || (Object.create ? function(a, n) {
  Object.defineProperty(a, "default", { enumerable: !0, value: n });
} : function(a, n) {
  a.default = n;
}), G = x && x.__importStar || function(a) {
  if (a && a.__esModule)
    return a;
  var n = {};
  if (a != null)
    for (var s in a)
      s !== "default" && Object.prototype.hasOwnProperty.call(a, s) && j(n, a, s);
  return U(n, a), n;
};
Object.defineProperty(A, "__esModule", { value: !0 });
A.Parser = void 0;
var E = G(w), B = O, N = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), l = /* @__PURE__ */ new Set(["p"]), D = /* @__PURE__ */ new Set(["thead", "tbody"]), k = /* @__PURE__ */ new Set(["dd", "dt"]), P = /* @__PURE__ */ new Set(["rt", "rp"]), z = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", l],
  ["h1", l],
  ["h2", l],
  ["h3", l],
  ["h4", l],
  ["h5", l],
  ["h6", l],
  ["select", N],
  ["input", N],
  ["output", N],
  ["button", N],
  ["datalist", N],
  ["textarea", N],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", k],
  ["dt", k],
  ["address", l],
  ["article", l],
  ["aside", l],
  ["blockquote", l],
  ["details", l],
  ["div", l],
  ["dl", l],
  ["fieldset", l],
  ["figcaption", l],
  ["figure", l],
  ["footer", l],
  ["form", l],
  ["header", l],
  ["hr", l],
  ["main", l],
  ["nav", l],
  ["ol", l],
  ["pre", l],
  ["section", l],
  ["table", l],
  ["ul", l],
  ["rt", P],
  ["rp", P],
  ["tbody", D],
  ["tfoot", D]
]), H = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), V = /* @__PURE__ */ new Set(["math", "svg"]), L = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), Q = /\s|\//, R = (
  /** @class */
  function() {
    function a(n, s) {
      s === void 0 && (s = {});
      var e, r, u, p, b;
      this.options = s, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = n ?? {}, this.lowerCaseTagNames = (e = s.lowerCaseTags) !== null && e !== void 0 ? e : !s.xmlMode, this.lowerCaseAttributeNames = (r = s.lowerCaseAttributeNames) !== null && r !== void 0 ? r : !s.xmlMode, this.tokenizer = new ((u = s.Tokenizer) !== null && u !== void 0 ? u : E.default)(this.options, this), (b = (p = this.cbs).onparserinit) === null || b === void 0 || b.call(p, this);
    }
    return a.prototype.ontext = function(n, s) {
      var e, r, u = this.getSlice(n, s);
      this.endIndex = s - 1, (r = (e = this.cbs).ontext) === null || r === void 0 || r.call(e, u), this.startIndex = s;
    }, a.prototype.ontextentity = function(n) {
      var s, e, r = this.tokenizer.getSectionStart();
      this.endIndex = r - 1, (e = (s = this.cbs).ontext) === null || e === void 0 || e.call(s, (0, B.fromCodePoint)(n)), this.startIndex = r;
    }, a.prototype.isVoidElement = function(n) {
      return !this.options.xmlMode && H.has(n);
    }, a.prototype.onopentagname = function(n, s) {
      this.endIndex = s;
      var e = this.getSlice(n, s);
      this.lowerCaseTagNames && (e = e.toLowerCase()), this.emitOpenTag(e);
    }, a.prototype.emitOpenTag = function(n) {
      var s, e, r, u;
      this.openTagStart = this.startIndex, this.tagname = n;
      var p = !this.options.xmlMode && z.get(n);
      if (p)
        for (; this.stack.length > 0 && p.has(this.stack[this.stack.length - 1]); ) {
          var b = this.stack.pop();
          (e = (s = this.cbs).onclosetag) === null || e === void 0 || e.call(s, b, !0);
        }
      this.isVoidElement(n) || (this.stack.push(n), V.has(n) ? this.foreignContext.push(!0) : L.has(n) && this.foreignContext.push(!1)), (u = (r = this.cbs).onopentagname) === null || u === void 0 || u.call(r, n), this.cbs.onopentag && (this.attribs = {});
    }, a.prototype.endOpenTag = function(n) {
      var s, e;
      this.startIndex = this.openTagStart, this.attribs && ((e = (s = this.cbs).onopentag) === null || e === void 0 || e.call(s, this.tagname, this.attribs, n), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, a.prototype.onopentagend = function(n) {
      this.endIndex = n, this.endOpenTag(!1), this.startIndex = n + 1;
    }, a.prototype.onclosetag = function(n, s) {
      var e, r, u, p, b, y;
      this.endIndex = s;
      var d = this.getSlice(n, s);
      if (this.lowerCaseTagNames && (d = d.toLowerCase()), (V.has(d) || L.has(d)) && this.foreignContext.pop(), this.isVoidElement(d))
        !this.options.xmlMode && d === "br" && ((r = (e = this.cbs).onopentagname) === null || r === void 0 || r.call(e, "br"), (p = (u = this.cbs).onopentag) === null || p === void 0 || p.call(u, "br", {}, !0), (y = (b = this.cbs).onclosetag) === null || y === void 0 || y.call(b, "br", !1));
      else {
        var f = this.stack.lastIndexOf(d);
        if (f !== -1)
          if (this.cbs.onclosetag)
            for (var I = this.stack.length - f; I--; )
              this.cbs.onclosetag(this.stack.pop(), I !== 0);
          else
            this.stack.length = f;
        else
          !this.options.xmlMode && d === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = s + 1;
    }, a.prototype.onselfclosingtag = function(n) {
      this.endIndex = n, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = n + 1) : this.onopentagend(n);
    }, a.prototype.closeCurrentTag = function(n) {
      var s, e, r = this.tagname;
      this.endOpenTag(n), this.stack[this.stack.length - 1] === r && ((e = (s = this.cbs).onclosetag) === null || e === void 0 || e.call(s, r, !n), this.stack.pop());
    }, a.prototype.onattribname = function(n, s) {
      this.startIndex = n;
      var e = this.getSlice(n, s);
      this.attribname = this.lowerCaseAttributeNames ? e.toLowerCase() : e;
    }, a.prototype.onattribdata = function(n, s) {
      this.attribvalue += this.getSlice(n, s);
    }, a.prototype.onattribentity = function(n) {
      this.attribvalue += (0, B.fromCodePoint)(n);
    }, a.prototype.onattribend = function(n, s) {
      var e, r;
      this.endIndex = s, (r = (e = this.cbs).onattribute) === null || r === void 0 || r.call(e, this.attribname, this.attribvalue, n === E.QuoteType.Double ? '"' : n === E.QuoteType.Single ? "'" : n === E.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, a.prototype.getInstructionName = function(n) {
      var s = n.search(Q), e = s < 0 ? n : n.substr(0, s);
      return this.lowerCaseTagNames && (e = e.toLowerCase()), e;
    }, a.prototype.ondeclaration = function(n, s) {
      this.endIndex = s;
      var e = this.getSlice(n, s);
      if (this.cbs.onprocessinginstruction) {
        var r = this.getInstructionName(e);
        this.cbs.onprocessinginstruction("!".concat(r), "!".concat(e));
      }
      this.startIndex = s + 1;
    }, a.prototype.onprocessinginstruction = function(n, s) {
      this.endIndex = s;
      var e = this.getSlice(n, s);
      if (this.cbs.onprocessinginstruction) {
        var r = this.getInstructionName(e);
        this.cbs.onprocessinginstruction("?".concat(r), "?".concat(e));
      }
      this.startIndex = s + 1;
    }, a.prototype.oncomment = function(n, s, e) {
      var r, u, p, b;
      this.endIndex = s, (u = (r = this.cbs).oncomment) === null || u === void 0 || u.call(r, this.getSlice(n, s - e)), (b = (p = this.cbs).oncommentend) === null || b === void 0 || b.call(p), this.startIndex = s + 1;
    }, a.prototype.oncdata = function(n, s, e) {
      var r, u, p, b, y, d, f, I, t, i;
      this.endIndex = s;
      var o = this.getSlice(n, s - e);
      this.options.xmlMode || this.options.recognizeCDATA ? ((u = (r = this.cbs).oncdatastart) === null || u === void 0 || u.call(r), (b = (p = this.cbs).ontext) === null || b === void 0 || b.call(p, o), (d = (y = this.cbs).oncdataend) === null || d === void 0 || d.call(y)) : ((I = (f = this.cbs).oncomment) === null || I === void 0 || I.call(f, "[CDATA[".concat(o, "]]")), (i = (t = this.cbs).oncommentend) === null || i === void 0 || i.call(t)), this.startIndex = s + 1;
    }, a.prototype.onend = function() {
      var n, s;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var e = this.stack.length; e > 0; this.cbs.onclosetag(this.stack[--e], !0))
          ;
      }
      (s = (n = this.cbs).onend) === null || s === void 0 || s.call(n);
    }, a.prototype.reset = function() {
      var n, s, e, r;
      (s = (n = this.cbs).onreset) === null || s === void 0 || s.call(n), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (r = (e = this.cbs).onparserinit) === null || r === void 0 || r.call(e, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, a.prototype.parseComplete = function(n) {
      this.reset(), this.end(n);
    }, a.prototype.getSlice = function(n, s) {
      for (; n - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var e = this.buffers[0].slice(n - this.bufferOffset, s - this.bufferOffset); s - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), e += this.buffers[0].slice(0, s - this.bufferOffset);
      return e;
    }, a.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, a.prototype.write = function(n) {
      var s, e;
      if (this.ended) {
        (e = (s = this.cbs).onerror) === null || e === void 0 || e.call(s, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(n), this.tokenizer.running && (this.tokenizer.write(n), this.writeIndex++);
    }, a.prototype.end = function(n) {
      var s, e;
      if (this.ended) {
        (e = (s = this.cbs).onerror) === null || e === void 0 || e.call(s, new Error(".end() after done!"));
        return;
      }
      n && this.write(n), this.ended = !0, this.tokenizer.end();
    }, a.prototype.pause = function() {
      this.tokenizer.pause();
    }, a.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, a.prototype.parseChunk = function(n) {
      this.write(n);
    }, a.prototype.done = function(n) {
      this.end(n);
    }, a;
  }()
);
A.Parser = R;
(function(a) {
  var n = x && x.__createBinding || (Object.create ? function(h, c, m, S) {
    S === void 0 && (S = m);
    var T = Object.getOwnPropertyDescriptor(c, m);
    (!T || ("get" in T ? !c.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return c[m];
    } }), Object.defineProperty(h, S, T);
  } : function(h, c, m, S) {
    S === void 0 && (S = m), h[S] = c[m];
  }), s = x && x.__setModuleDefault || (Object.create ? function(h, c) {
    Object.defineProperty(h, "default", { enumerable: !0, value: c });
  } : function(h, c) {
    h.default = c;
  }), e = x && x.__importStar || function(h) {
    if (h && h.__esModule)
      return h;
    var c = {};
    if (h != null)
      for (var m in h)
        m !== "default" && Object.prototype.hasOwnProperty.call(h, m) && n(c, h, m);
    return s(c, h), c;
  }, r = x && x.__importDefault || function(h) {
    return h && h.__esModule ? h : { default: h };
  };
  Object.defineProperty(a, "__esModule", { value: !0 }), a.DomUtils = a.parseFeed = a.getFeed = a.ElementType = a.Tokenizer = a.createDomStream = a.parseDOM = a.parseDocument = a.DefaultHandler = a.DomHandler = a.Parser = void 0;
  var u = A, p = A;
  Object.defineProperty(a, "Parser", { enumerable: !0, get: function() {
    return p.Parser;
  } });
  var b = q, y = q;
  Object.defineProperty(a, "DomHandler", { enumerable: !0, get: function() {
    return y.DomHandler;
  } }), Object.defineProperty(a, "DefaultHandler", { enumerable: !0, get: function() {
    return y.DomHandler;
  } });
  function d(h, c) {
    var m = new b.DomHandler(void 0, c);
    return new u.Parser(m, c).end(h), m.root;
  }
  a.parseDocument = d;
  function f(h, c) {
    return d(h, c).children;
  }
  a.parseDOM = f;
  function I(h, c, m) {
    var S = new b.DomHandler(h, c, m);
    return new u.Parser(S, c);
  }
  a.createDomStream = I;
  var t = w;
  Object.defineProperty(a, "Tokenizer", { enumerable: !0, get: function() {
    return r(t).default;
  } }), a.ElementType = e(M);
  var i = _, o = _;
  Object.defineProperty(a, "getFeed", { enumerable: !0, get: function() {
    return o.getFeed;
  } });
  var g = { xmlMode: !0 };
  function v(h, c) {
    return c === void 0 && (c = g), (0, i.getFeed)(f(h, c));
  }
  a.parseFeed = v, a.DomUtils = e(_);
})(F);
export {
  F as l
};
